import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from 'app/directives/directives.module';
import { MatTabsModule } from '@angular/material/tabs';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatChipsModule } from '@angular/material/chips';
import { FileManagerComponent } from './components/file-manager/file-manager.component';
import { InputDialogComponent } from './components/file-manager/input-dialog/input-dialog.component';
// import { AvatarModule } from 'ngx-avatar';
import { MatRadioModule } from '@angular/material/radio';
import { FlexLayoutModule } from '@angular/flex-layout';
import { GuardedInputComponent } from './components/inputs/guarded-input/guarded-input.component';
import { EvaluatePipe } from './pipes/evaluate.pipe';
import { GetFromArrayByPipe } from './pipes/get-from-array-by.pipe';
import { ExistInPipe } from './pipes/exists-in.pipe';
import { KeyValueTranslatePipe } from './pipes/key-value-translate.pipe';
import { DateInputComponent } from './components/inputs/date-input/date-input.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { SelectInputComponent } from './components/inputs/select-input/select-input.component';
import { TextInputComponent } from './components/inputs/text-input/text-input.component';
import { TextAreaInputComponent } from './components/inputs/text-area-input/text-area-input.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTreeModule } from '@angular/material/tree';
import { SelectMultipleInputComponent } from './components/inputs/select-multiple-input/select-multiple-input.component';
import { OverlayModule } from '@angular/cdk/overlay';
import { FuseSharedModule } from '@fuse/shared.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatBadgeModule } from '@angular/material/badge';
import {MatCardModule} from '@angular/material/card';
import {SafePipe} from "./pipes/safe.pipe";
import {RadioGroupComponent} from "./components/inputs/radio-group-input/radio-group.component";
import {TextListInputComponent} from "./components/inputs/text-list-input/text-list-input.component";
import {StatusSelectorComponent} from "./components/inputs/status-selector-input/status-selector.component";
import {TableInputComponent} from "./components/inputs/table-input/table-input.component";
import { PublicFilesService } from 'app/services/public-files.service';
import {FilesInputComponent} from "./components/inputs/files-input/files-input.component";
import { FilterPipe } from './pipes/filter.pipe';
import {TemplateInputComponent} from "./components/inputs/template-input/template-input.component";
import { SuggestInputComponent } from './components/suggest-input/suggest-input.component';
import { ComplaintChatComponent } from './components/complaint-chat.component.ts/complaint-chat.component';
import { SimpleFileUploaderModule } from 'app/modules/simple-file-uploader/simple-file-uploader.module';
import { DateRangeComponent } from './components/inputs/date-range/date-range.component';
import { CaptchaComponent } from './components/captcha/captcha.component';

const COMPONENTS = [
  FileManagerComponent,
  InputDialogComponent,
  GuardedInputComponent,
  DateInputComponent,
  SelectInputComponent,
  TextInputComponent,
  TextAreaInputComponent,
  SelectMultipleInputComponent,
  RadioGroupComponent,
  TextListInputComponent,
  StatusSelectorComponent,
  TableInputComponent,
  FilesInputComponent,
  TemplateInputComponent,
  SuggestInputComponent,
  // ComplaintChatComponent,
  DateRangeComponent,
  CaptchaComponent
];

const PIPES = [
  EvaluatePipe,
  ExistInPipe,
  SafePipe,
  KeyValueTranslatePipe,
  FilterPipe,
];

const MODULES = [
  DirectivesModule,
  // AvatarModule,
  SimpleFileUploaderModule,
];

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatTableModule,
    MatSortModule,
    MatExpansionModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatDialogModule,
    MatSelectModule,
    MatSidenavModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatTabsModule,
    MatDatepickerModule,
    MatChipsModule,
    MatRadioModule,
    MatSlideToggleModule,
    MatTreeModule,
    MatBadgeModule,
    FlexLayoutModule,
    OverlayModule,
    FuseSharedModule,
    MatProgressBarModule,
    MatCardModule,
    
    ...MODULES
  ],
  exports: [
    CommonModule,
    TranslateModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatTableModule,
    MatSortModule,
    MatExpansionModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatSelectModule,
    MatSidenavModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    MatSnackBarModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    MatTabsModule,
    MatDatepickerModule,
    MatChipsModule,
    MatRadioModule,
    MatSlideToggleModule,
    OverlayModule,
    FuseSharedModule,
    MatProgressBarModule,
    MatBadgeModule,
    MatCardModule,
    ...MODULES,
    ...COMPONENTS,
    ...PIPES,
    GetFromArrayByPipe,
    MatTreeModule,
    ComplaintChatComponent
  ],
  declarations: [
    ...COMPONENTS,
    ...PIPES,
    GetFromArrayByPipe,
    ComplaintChatComponent,
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'es-AR' },
    PublicFilesService
  ]
})
export class SharedModule {
}
